<template>
<div class="row">

  <aside class="col-md-3 col-sm-12 cus-sidebar">
      <ResourceSidebar />
  </aside>
  <div id="content" class="col-md-9 col-sm-12">
    <div class="material-box bg-white">
      <div class="row content-row">
        <div class="col-md-12 top-title">
          <h3>Vendors</h3>
        </div>
        <div class="col-md-12">
          <div class=""> 
              <div class="row">
                <div class="col-md-12 box-detail">
                  <p class="m-0">Please consider these professionals, when searching for supportive services for your practice.</p>
                </div>
              </div>
             </div>
        </div>
      </div>
    </div>
    <div>
  <div class="row shell_total-nopadd">
    <div v-for="vendor in vendors" :key="vendor.VendorID" class="col-md-6">
      <div class="material-box bg-white">
        <div class="row content-row">
          <div class="col-md-12 top-title">
            <h3 class="text-center">{{ vendor.VendorName }}</h3>
          </div>
          <div class="col-md-12">
            <div class="p-b-10">
              <div class="row">
                <div class="col-md-12 box-detail">
                  <p class="m-0 text-center">{{ vendor.VendorPhone }}</p>
                  <p class="m-0 text-center target-p" @click="openSiteURL(vendor.VendorURL)"><a href="javascript:void(0)">{{ vendor.VendorURL }}</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <div class="material-box bg-white">
      <div class="row content-row">
        <div class="col-md-12">
          <div class="">
            <div class="row">
              <div class="col-md-12 box-detail">
                <p class="m-t-10 m-b-0">Each of these have proven to be valueable resources, for growing practices just like yours.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</div>

</template>

<script>
import userAPI from "../userApi";
import ResourceSidebar from './components/ResourceSidebar.vue';
export default {
  components: { ResourceSidebar },
    name: "Module",
    data() {
        return {
            VendorID: "",
            vendors:[],
        }
    },
    methods: {
      getResourcesVendors() {
            userAPI.getResourcesVendors(res => {
                this.vendors = res.data.data;
            }, err => {
                console.log(err);
            })
        },
        openSiteURL(url) {
          // Check if the URL starts with "http://" or "https://"
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            // If not, add "https://"
            url = 'https://' + url;
          }
         console.log('nww url ', url);

          window.open(url, '_blank');
        },

        
    },
    mounted() {
      this.getResourcesVendors();
    },
}
</script>
./components/ResourceSidebar.vue